module.exports = __webpack_public_path__ + "img/syukyaku-kyoutu-logo003.a9f59aec.png";